import { useDispatch } from 'react-redux';

import { LmRadio } from '@mes-ui/lemma';
import { Typography, useMediaQuery } from '@mui/material';
import { linkSharingDrawerActions } from 'actions';
import FunnelBlock from 'components/common/FunnelBlock';
import { useAppSelector } from 'hooks';
import { FormatType } from 'portfolio3/features/pdf/types';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { commonTheme } from 'portfolio3/styles/theme';
import { activeFormatSelector } from 'selectors/drawers';

import './index.scss';

const Format = () => {
  const dispatch = useDispatch();
  const activeFormat = useAppSelector(activeFormatSelector);
  const isMobile = useMediaQuery(commonTheme.breakpoints.down('commonSm'));
  const handleChangeRadio = (value: boolean, name: string) => {
    emitYMEvent({
      type: 'sharePortfolio_format_choice_click',
      payload: {
        formatChoice: name as FormatType,
      },
    });
    dispatch(linkSharingDrawerActions.setActiveFormat(name as 'horizontal' | 'vertical'));
  };

  return (
    <FunnelBlock className="format">
      <Typography variant={isMobile ? 'Headings/H6' : 'Headings/H5'}>Формат</Typography>
      <LmRadio checked={activeFormat === 'vertical'} onChange={handleChangeRadio} name="vertical">
        Вертикальный
      </LmRadio>
      <LmRadio checked={activeFormat === 'horizontal'} onChange={handleChangeRadio} name="horizontal">
        Горизонтальный
      </LmRadio>
    </FunnelBlock>
  );
};

export default Format;
